import React from 'react';
import { Redirect } from 'expo-router';

// REQUEST/chat de negociação de recorrência desativado no front por ora.
// Tela original preservada abaixo para reativar depois.
export default function ClientChatListScreen() {
  return <Redirect href="/(tabs)/(client)/appointments" />;
}

/*
import { router } from 'expo-router';
import { ConversationList } from '@/components/schedule/conversation-list';

export default function ClientChatListScreen() {
  return (
    <ConversationList
      title="Conversas"
      viewer="client"
      onBack={() => router.back()}
      onOpen={c => router.push(`/(tabs)/(client)/chat/${c.id}`)}
    />
  );
}
*/
